import { Button, Col, Descriptions, Input, Row } from "antd";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import FormInput from "../../component/FormInput";
import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  UpOutlined,
} from "@ant-design/icons";
import {
  INPUT_TYPE,
  KEY,
  lang,
  MODE_SCREEN,
  STYLE,
} from "../../constants/common.const";
import "./equipment.scss";
import EquipmentContentModal from "./equipmentContentModal";
import classText from "../../models/control/text";
import { formatDecimal, formatNumberFloat, formatNumberFloatKeepDecmal } from "../../utils/helper";
function EquipmentPrimeMover({
  listData = [],
  mode,
  handlechangeInput = () => {},
  listAuxiliaryEngine = [],
  setPrimeMoverData,
  primeMoverData,
  clickSave,
  setIsDirty
}) {
  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });
  const data = listData
  
  // Change Input
  const changeInput = (e, item) => {
    const value = e.target ? e.target.value : e;
    handlechangeInput(item.key, value, item.rule, item.type);
  };
  const renderInput = (item) => {
    if (mode !== MODE_SCREEN.VIEW) {
      if (item.type === INPUT_TYPE.MODAL) {
        return (
          <EquipmentContentModal
            error={item.error}
            onCancel={item.onCancel}
            onOK={item.onOk}
            compo={item.modalComponent}
            value={item.value.label}
            labelButton={item.labelButton}
          ></EquipmentContentModal>
        );
      }
      return (
        <FormInput
          onChange={(e) => {
            if (item.customChange) {
              item.customChange(e);
            return;
            }
            changeInput(e, item);
            
          }}
          valueObject={item.value}
          disabled={item.disabled}
          refer={item.refer}
          haveEmptyOption={item.haveEmptyOption}
          onBlur={(e) => {
           if(item.type === INPUT_TYPE.INPUT && item.isDecimal){
            const value = e.target.value
            let finalValue = String(value).replace(/,/g, "") 
            finalValue = formatDecimal(finalValue,item.isDecimal);
            setPrimeMoverData({
              ...primeMoverData,
              [item.key]:{
                ...primeMoverData[item.key],
                value:formatNumberFloatKeepDecmal(finalValue)
              }
            })
           
           }
          }}
          {...item}
        />
      );
    }
    if (item.type === INPUT_TYPE.SWITCH) {
      return item.value.valueString || "";
    }
    if (item.type === INPUT_TYPE.SELECT) {
      return item.value.label;
    }
    return item.type === INPUT_TYPE.DATE
      ? item.value.valueString
      : item.value.label || item.value.value;
  };

  const renderDescriptions = (list) => {
    return (
      <Descriptions className="customEquipmentDes" size="small" column={2} bordered>
        {list.map((item, index) => (
          <Descriptions.Item
            style={{ width: item.span == 1 ? "30%" : "80%" }}
            labelStyle={{
              width: "20%",
              fontWeight: "bold",
            }}
            contentStyle={{ padding: "4px 4px" }}
            key={index}
            label={
              <div className="labelInputEquipment">
                {item.title}
                {mode !== MODE_SCREEN.VIEW && item.required && (
                  <span style={{ color: "red" }}>*</span>
                )}
              </div>
            }
            span={item.span || 1}
          >
            {renderInput(item)}
          </Descriptions.Item>
        ))}
      </Descriptions>
    );
  };
  const handleAddRow = () => {
    const newRow = {
      key: Date.now(),
      value: new classText(),
      title: new classText(),
    };
    const newListAuxiliaryEngine = listAuxiliaryEngine.concat(newRow);

    //   const new
    setPrimeMoverData({
      ...primeMoverData,
      listAuxiliaryEngine: newListAuxiliaryEngine,
    });
  };
  const handleDeleteRow = (key) => {
    const newListAuxiliaryEngine = listAuxiliaryEngine.filter(
      (item) => item.key !== key
    );
    setPrimeMoverData({
      ...primeMoverData,
      listAuxiliaryEngine: newListAuxiliaryEngine,
    });
  };
  const handleChangeValueRow = (key, field, value) => {
    const newListAuxiliaryEngine = listAuxiliaryEngine.map((item) => {
      if (item.key === key) {
        return {
          ...item,
          [field]: new classText(value),
        };
      }
      return item;
    });
    setPrimeMoverData({
      ...primeMoverData,
      listAuxiliaryEngine: newListAuxiliaryEngine,
    });
    setIsDirty(true)
  };
  const renderInputListAuxiliaryEngine = (list) => {
    return list.map((item, index) => (
      <Row
        key={index}
        align="middle"
        gutter={8}
        style={{
          marginBottom: 8,
        }}
        className="mt10"
      >
        <Col className="mr10" style={{ width: 36 }}>
          <Button
            onClick={() => {
              handleDeleteRow(item.key);
              setIsDirty(true)
            }}
            icon={
              <DeleteOutlined
                style={{
                  color: "red",
                }}
              />
            }
            size="small"
            style={{
              width: 32,
              height: 32,
              minWidth: 32,
              borderRadius: 4,
            }}
          />
        </Col>
        <Col flex={1}>
          <Input
            className={
              String(item.title.value).trim() === "" &&
              String(item.value.value).trim() &&
              clickSave
                ? STYLE.BORDER_RED
                : ""
            }
            onChange={(e) => {
              handleChangeValueRow(item.key, "title", e.target.value);
            }}
            value={item.title.value}
          />
        </Col>
        <Col flex={2}>
          <Input
            className={
              String(item.title.value).trim() &&
              String(item.value.value).trim() === "" &&
              clickSave
                ? STYLE.BORDER_RED
                : ""
            }
            onChange={(e) => {
              handleChangeValueRow(item.key, "value", e.target.value);
            }}
            value={item.value.value}
          />
        </Col>
      </Row>
    ));
  };
  if (mode === MODE_SCREEN.VIEW) {
    listAuxiliaryEngine.forEach((item) => {
      const finalItem = {
        ...item,
        title: item.title.value,
        type: INPUT_TYPE.INPUT,
        rule: [],
        span: 2,
      };
      data.push(finalItem);
    });
  }
  return (
    <div  style={{
      overflowX:"hidden"
    }}>
      {renderDescriptions(data)}
      {mode !== MODE_SCREEN.VIEW &&
        renderInputListAuxiliaryEngine(listAuxiliaryEngine)}
      {mode !== MODE_SCREEN.VIEW && (
        <div className={"mt15"}>
          <Button
            disabled={listAuxiliaryEngine.length >= 2}
            className="buttonPC button--info"
            onClick={() => {
              handleAddRow();
            }}
          >
            <PlusOutlined /> {lang.ADD}
          </Button>
        </div>
      )}
    </div>
  );
}

export default EquipmentPrimeMover;
